import { Controller } from "@hotwired/stimulus"

const NUMERIC_TYPES = ["engagement_rate", "reach", "views", "impressions", "shares", "video_views", "saves"]

export default class extends Controller {
  static targets = ["container", "condition", "emptyState", "template", "conditionTypeSection", "textInputs", "numericInputs"]

  connect() {
    console.log("[condition-builder] connect:", this.conditionTargets.length, "conditions")
    this.updateEmptyState()
  }

  addCondition() {
    const index = this.conditionTargets.length
    const template = this.templateTarget
    const content = template.innerHTML.replace(/INDEX/g, index)
    const wrapper = document.createElement("div")
    wrapper.innerHTML = content
    const node = wrapper.firstElementChild
    this.containerTarget.appendChild(node)
    this.updateEmptyState()
    console.log("[condition-builder] added condition at index", index)
  }

  removeCondition(event) {
    const condition = event.target.closest("[data-condition-builder-target='condition']")
    if (condition) {
      condition.remove()
      this.renumberConditions()
      this.updateEmptyState()
      console.log("[condition-builder] removed condition, remaining:", this.conditionTargets.length)
    }
  }

  typeChanged(event) {
    const select = event.target
    const conditionRow = select.closest("[data-condition-builder-target='condition']")
    if (!conditionRow) return

    const selectedType = select.value
    const isNumeric = NUMERIC_TYPES.includes(selectedType)

    const textInputs = conditionRow.querySelector("[data-condition-builder-target='textInputs']")
    const numericInputs = conditionRow.querySelector("[data-condition-builder-target='numericInputs']")

    if (textInputs) textInputs.style.display = isNumeric ? "none" : ""
    if (numericInputs) numericInputs.style.display = isNumeric ? "" : "none"

    console.log("[condition-builder] type changed to", selectedType, "numeric:", isNumeric)
  }

  renumberConditions() {
    this.conditionTargets.forEach((condition, index) => {
      condition.querySelectorAll("[name]").forEach(input => {
        input.name = input.name.replace(/\[\d+\]/, `[${index}]`)
      })
    })
  }

  updateEmptyState() {
    const hasConditions = this.conditionTargets.length > 0
    this.emptyStateTarget.classList.toggle("hidden", hasConditions)
    if (this.hasConditionTypeSectionTarget) {
      this.conditionTypeSectionTarget.classList.toggle("hidden", !hasConditions)
    }
  }

  disconnect() {
    console.log("[condition-builder] disconnect")
  }
}
